<template>
  <div class="overall-setup">
    <AdditionalSetupRV3434 v-if="isRubetekRV3434" />
    <AdditionalSetup v-else />
    <div v-if="roleName === 'admin' && doorphone" class="overall-setup__report mt-4">
      <div class="overall-setup__report-header">
        <v-icon color="primary" class="overall-setup__header-icon">mdi-file-document-outline</v-icon>
        <h2 class="overall-setup__title">Настройки отчёта</h2>
      </div>
      <v-row>
      <v-col cols="12" md="6" class="pb-0">
        <v-card-text class="pl-0 pb-0">Адрес {{ doorphone.address }}</v-card-text>
        <v-card-text class="pl-0 pt-0 mb-2">Диапазон квартир: {{ doorphone.diapason_from }} - {{ doorphone.diapason_to }}</v-card-text>
        <v-row>
          <v-col cols="12" md="8" class="py-0">
            <v-text-field
              v-model="amountApartment"
              flat
              outlined
              dense
              label="Сумма квартир"
              prepend-inner-icon="mdi-home-city-outline"
              append-icon="mdi-information-outline"
              @click:append="info = !info"
              class="overall-setup__field"
            />
            <v-col v-if="info" class="pt-0">
              <p class="caption">Изменение суммы квартир для полного отчёта "списка домофона"</p>
            </v-col>
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <v-btn
              color="primary"
              class="text-none"
              dark
              rounded
              @click="changeAmountApartments()"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Изменить
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AdditionalSetup from './components/AdditionalSetup';
import AdditionalSetupRV3434 from './components/AdditionalSetupRV3434';

export default {
  name: 'OverallSetup',
  components: { AdditionalSetup, AdditionalSetupRV3434 },
  data: () => ({
    amountApartment: null,
    info: false,
  }),
  mounted () {
    const d = this.doorphoneEditInfo && this.doorphoneEditInfo.doorphone;
    if (d && d.diapason_file) {
      this.amountApartment = d.diapason_file;
    }
  },
  computed: {
    ...mapGetters({
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
      roleName: 'roleName',
    }),
    isRubetekRV3434 () {
      const d = this.doorphoneEditInfo && this.doorphoneEditInfo.doorphone;
      return d && d.model === 'RV-3434';
    },
    doorphone () {
      return this.doorphoneEditInfo && this.doorphoneEditInfo.doorphone ? this.doorphoneEditInfo.doorphone : null;
    },
  },
  methods: {
    ...mapActions({
      updateDoorphone: 'Doorphone/updateDoorphone',
    }),
    changeAmountApartments () {
      if (this.amountApartment === null || !this.doorphone) {
        this.$flash_danger('Введите сумму кв');
      } else {
        const tempDoorphone = {
          diapason_file: +this.amountApartment,
          device_id: this.doorphone.device_id,
          payment_type: this.doorphone.payment_type,
          free_keys: this.doorphone.free_keys,
        };
        this.updateDoorphone({
          id: this.$route.params.id,
          doorphone: tempDoorphone,
        })
          .then(() => {
            this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Ошибка при изменении информации о домофоне');
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.overall-setup__report-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.overall-setup__header-icon {
  flex-shrink: 0;
}

.overall-setup__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.overall-setup__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}
</style>
